import React from "react";

//Librerias
import { Link, useLocation } from "react-router-dom";
import { Can } from "../../../../common/config/Can";

//Componentes de Material UI
import {
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

//Iconos de Material UI
import { AccountBoxOutlined as DescriptionIcon, FactCheckOutlined as FactCheckIcon } from "@mui/icons-material";


const ListAdmin = ({ toggleDrawer }) => {
    //===============================================================================================================================================
    //========================================== Hooks personalizados ===============================================================================
    //===============================================================================================================================================
    const location = useLocation();

    //===============================================================================================================================================
    //========================================== Renders ============================================================================================
    //===============================================================================================================================================
    return (
        <List sx={{maxWidth: 360, bgcolor: '#000' }}>
            <Can I="view" a="Admin">
                <ListItemButton
                    component={Link}
                    to="/wilson/admin/users"
                    selected={location.pathname.startsWith(
                        "/wilson/admin/users"
                    )}
                    onClick={(e) => toggleDrawer(e, false)}
                >
                    <ListItemIcon >
                        <DescriptionIcon sx={{color:"#fff"}} />
                    </ListItemIcon>
                    <ListItemText sx={{color:"#fff"}} primary="Gestionar información colaborador" />
                </ListItemButton>
            </Can>
            <Can I="view" a="Reconocimientos">
                <ListItemButton
                    component={Link}
                    to="/wilson/admin/reconocimientos/aprobacion"
                    selected={location.pathname.startsWith(
                        "/wilson/admin/reconocimientos/aprobacion"
                    )}
                    onClick={(e) => toggleDrawer(e, false)}
                >
                    <ListItemIcon >
                        <FactCheckIcon sx={{color:"#fff"}} />
                    </ListItemIcon>
                    <ListItemText sx={{color:"#fff"}} primary="Aprobar reconocimientos" />
                </ListItemButton>
            </Can>
        </List>
    );
};

export default ListAdmin;
